import { toDateTimeStr } from '@mi-front/core';
import { DurationForRange } from '@mi-front/ui';
import { ChunksRangeConverter } from '../../../joint-fragments/helpers/chunks-range-converter';
import { Fragment } from '../../types';

export function FragmentDuration(p: { fragment: Fragment }) {
  const { fragment } = p;
  const converter = new ChunksRangeConverter(fragment.chunks);

  return (
    <DurationForRange
      from={toDateTimeStr(converter.getRelativeRange().from)}
      to={toDateTimeStr(converter.getRelativeRange().to)}
    />
  );
}
